var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar-Icon",
    transform: "translate(0.000000, 0.000000)",
    fill: "#0C1229",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333,1.33333 L7.33333,0 L8.66667,0 L8.66667,1.33333 L15.3333,1.33333 L15.3333,0 L16.6667,0 L16.6667,1.33333 L20,1.33333 C21.4728,1.33333 22.6667,2.52724 22.6667,4 L22.6667,22.6667 C22.6667,24.1394 21.4728,25.3333 20,25.3333 L4,25.3333 C2.52724,25.3333 1.33333,24.1394 1.33333,22.6667 L1.33333,4 C1.33333,2.52724 2.52724,1.33333 4,1.33333 L7.33333,1.33333 Z M15.3333,2.66667 L8.66667,2.66667 L8.66667,4 L7.33333,4 L7.33333,2.66667 L4,2.66667 C3.26362,2.66667 2.66667,3.26362 2.66667,4 L2.66667,8 L21.3333,8 L21.3333,4 C21.3333,3.26362 20.7364,2.66667 20,2.66667 L16.6667,2.66667 L16.6667,4 L15.3333,4 L15.3333,2.66667 Z M21.3333,9.33333 L2.66667,9.33333 L2.66667,22.6667 C2.66667,23.403 3.26362,24 4,24 L20,24 C20.7364,24 21.3333,23.403 21.3333,22.6667 L21.3333,9.33333 Z M6.66667,12 L9.33333,12 L9.33333,14.6667 L6.66667,14.6667 L6.66667,12 Z M10.6667,12 L13.3333,12 L13.3333,14.6667 L10.6667,14.6667 L10.6667,12 Z M14.6667,12 L17.3333,12 L17.3333,14.6667 L14.6667,14.6667 L14.6667,12 Z M6.66667,16 L9.33333,16 L9.33333,18.6667 L6.66667,18.6667 L6.66667,16 Z M10.6667,16 L13.3333,16 L13.3333,18.6667 L10.6667,18.6667 L10.6667,16 Z M14.6667,16 L17.3333,16 L17.3333,18.6667 L14.6667,18.6667 L14.6667,16 Z M6.66667,20 L9.33333,20 L9.33333,22 L6.66667,22 L6.66667,20 Z M10.6667,20 L13.3333,20 L13.3333,22 L10.6667,22 L10.6667,20 Z",
    id: "Icon-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ebac981ee35c45801782dfdca387a317.svg";
export { ForwardRef as ReactComponent };